import { Injectable } from "@angular/core";
// import { Actions, createEffect } from "@ngrx/effects";
// // import { Store } from "@ngrx/store";
// import { GTMService } from "./googleTagManager.service";
// import { filterActions } from "src/app/shared/utilities/state/Operators";
// import { addGuestVehicle } from "../myqq";
// import { tap } from "rxjs/operators";
// import { SegmentEvents } from "../segment/segment.models";

@Injectable()
export class GTMChainEffects {
  constructor() {}

  // readonly productAddedGtmEvent = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       filterActions(addGuestVehicle.success),
  //       tap((action: any) => {
  //         if (!!action?.value) {
  //           this.gtmService.pushEventTag(SegmentEvents.PRODUCT_ADDED, action.value );
  //         }
  //       })
  //     ),
  //   { dispatch: false }
  // );
}
